import { Module } from 'vuex';

import initialStateSubscribable from '@/shared/mixins/store/subscribableData/initialState';
import initialStateSyncable from '@/shared/mixins/store/syncableData/initialState';
import { RootState } from '@/store/types';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import type { DaturaAssessmentState } from './types';

export function initialState(): DaturaAssessmentState {
  return {
    ...initialStateSubscribable(),
    ...initialStateSyncable(),
    tableDataMetadata: {},
    hot: null,
    userColumnSettings: {},
  };
}

const vuexModule: Module<DaturaAssessmentState, RootState> = {
  namespaced: true,
  state: initialState(),
  mutations,
  actions,
  getters,
};

export default vuexModule;
